const PROJECT_ID_PATTERN = /^[A-Za-z0-9_-]{8,200}$/;

/**
 * Project IDs are generated locally and used as IndexedDB keys. Keep the
 * accepted input deliberately narrow so a pasted value cannot become a URL,
 * database, or DOM injection vector if the storage implementation changes.
 */
export function normalizeProjectId(value: string): string | null {
  const id = value.trim();
  return PROJECT_ID_PATTERN.test(id) ? id : null;
}
